module.exports = __webpack_public_path__ + "static/media/verified-blue.8e0583eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/verified-blue.svg
// module id = 19
// module chunks = 0